import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Select from 'components/ui/SelectField';
import DatePicker from 'components/ui/DatePicker';
import Form from 'components/ui/Form';
import Spacer from 'components/ui/Spacer';

import { media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const StyledRow = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  ${media.mobile`
    flex-direction: column;
  `};
`;

const StyledItem = styled.div`
  width: 100%;
  text-align: ${props => props.textAlign || 'left'};
  margin: ${props => props.margin || '0px'};
`;

const StyledItemLabel = styled.div`
  margin-bottom: 5px;
`;

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`;

const StyledError = styled.div`
  color: ${colors.YUHU_RED};
`;

const FormTitle = styled.span`
  font-size: 20px;
  font-family: 'Circular-Bold';
`;

const EnvironmentalTesting = ({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  readOnly,
}) => {
  const [environmentalTesting, setEnvironmentalTesting] = useState(false);
  const [environmentalTestingResults, setEnvironmentalTestingResults] = useState(
    values.environmental_testing_result
  );
  useEffect(
    () => {
      if (values.environmental_testing) {
        setEnvironmentalTesting(true);
      }
    },
    [values.environmental_testing]
  );
  return (
    <React.Fragment>
      <StyledContainer>
        <Spacer mb={0.3}>
          <FormTitle>
            {getTranslatedString(
              'landlordPortal.maintenance.tickets.environmentalTesting.environmentalTesting'
            )}
          </FormTitle>
        </Spacer>
        <StyledRow>
          <StyledItem>
            <StyledItemLabel>
              {getTranslatedString(
                'landlordPortal.maintenance.tickets.environmentalTesting.hasBeenCompleted'
              )}
              *
            </StyledItemLabel>
            <Select
              name="environmental_testing"
              showSearch
              placeholder={getTranslatedString(
                'landlordPortal.maintenance.tickets.environmentalTesting.select'
              )}
              size="large"
              value={values.environmental_testing}
              disabled={readOnly}
              onChange={value => {
                setFieldValue('environmental_testing', value);
                value ? setEnvironmentalTesting(true) : setEnvironmentalTesting(false);
              }}
            >
              <Select.Option value={true}>
                {getTranslatedString('landlordPortal.maintenance.tickets.environmentalTesting.yes')}
              </Select.Option>
              <Select.Option value={false}>
                {getTranslatedString('landlordPortal.maintenance.tickets.environmentalTesting.no')}
              </Select.Option>
            </Select>
            {errors.environmental_testing &&
              touched.environmental_testing && (
                <StyledError>{errors.environmental_testing}</StyledError>
              )}
          </StyledItem>
        </StyledRow>
        {environmentalTesting && (
          <React.Fragment>
            <StyledRow>
              <StyledItem>
                <StyledItemLabel>
                  {getTranslatedString(
                    'landlordPortal.maintenance.tickets.environmentalTesting.results'
                  )}
                  *
                </StyledItemLabel>
                <Select
                  name="environmental_testing_results"
                  showSearch
                  placeholder={getTranslatedString(
                    'landlordPortal.maintenance.tickets.environmentalTesting.select'
                  )}
                  size="large"
                  value={values.environmental_testing_result}
                  disabled={readOnly}
                  onChange={value => {
                    setFieldValue('environmental_testing_result', value);
                    value
                      ? setEnvironmentalTestingResults(true)
                      : setEnvironmentalTestingResults(false);
                  }}
                >
                  <Select.Option value={true}>
                    {getTranslatedString(
                      'landlordPortal.maintenance.tickets.environmentalTesting.positive'
                    )}
                  </Select.Option>
                  <Select.Option value={false}>
                    {getTranslatedString(
                      'landlordPortal.maintenance.tickets.environmentalTesting.negative'
                    )}
                  </Select.Option>
                </Select>
                {errors.environmental_testing_results &&
                  touched.environmental_testing && (
                    <StyledError>{errors.environmental_testing_results}</StyledError>
                  )}
              </StyledItem>
            </StyledRow>
            {environmentalTestingResults && (
              <StyledRow>
                <StyledItem>
                  <StyledItemLabel>
                    {getTranslatedString(
                      'landlordPortal.maintenance.tickets.environmentalTesting.dateOfAbatement'
                    )}
                  </StyledItemLabel>
                  <Form.Item>
                    <StyledDatePicker
                      size="large"
                      value={values.abatement_date}
                      defaultPickerValue={moment().locale(getCurrentLocale())}
                      showToday={false}
                      placeholder="e.g. 2020-01-01"
                      disabled={readOnly}
                      mobileMode="date"
                      onChange={value => setFieldValue('abatement_date', value)}
                    />
                  </Form.Item>
                </StyledItem>
              </StyledRow>
            )}
          </React.Fragment>
        )}
      </StyledContainer>
    </React.Fragment>
  );
};

export default EnvironmentalTesting;
